export const BASE_PATH = '/member'
export const NOT_FOUND = '/404'
export const SORRY = '/sorry'

export const SIGN_IN = '/sign_in'
export const FORGOT_PASSWORD = '/auth/forgot_password'
export const AUTH_FACEBOOK = '/auth/facebook'

export const MYPAGE = '/companies'
export const CONTRIBUTIONS = '/contributions'
export const CONTRIBUTIONS_NEW = '/companies/company_contributions/new'
export const MY_CONTRIBUTIONS = '/companies/company_contributions'
export const CONTRIBUTIONS_KEYWORD = '/contributions/keywords'

export const contributionDetail = (id: number) =>
  `/contributions/detail?id=${id}`
export const editContribution = (id: number) =>
  `/companies/company_contributions/edit?id=${id}`

export const EDIT_PROFILE = '/companies/edit-profile'
export const EDIT_COMPANY = '/companies/edit-company'
export const EDIT_SETTLER = '/companies/edit-settler'
export const EDIT_NEEDS = '/companies/company_self_needs_edit'

export const EDIT_PASSWORD = '/companies/edit-passwords'

export const messageUrl = (roomUniqueId: string) =>
  `/companies/messages?room_id=${roomUniqueId}`

export const greet = (roomUniqueId: string) =>
  `/companies/messages/greet?room_id=${roomUniqueId}`

export const EVENTS = '/events'
export const eventDetail = (id: number) => `/events/detail?id=${id}`
export const USAGE_HISTORIES = '/companies/usage_histories'
